import OperationsInfo from '@/components/OperationsInfo/OperationsInfo';

export default OperationsInfo;
